import React, { createContext, useContext, useState } from "react";
import axios from "axios";
import { useMarketToggle } from "../context/MarketContext";
const IndicatorContext = createContext();
// const BASE_URL = "http://localhost:8000";
const BASE_URL = process.env.REACT_APP_API_BASE_URL;
export const IndicatorProvider = ({ children }) => {
  const { market } = useMarketToggle();
  const [dailyRSI, setDailyRSI] = useState(null);
  const [dailyMACD, setDailyMACD] = useState(null);

  const [intradayRSI, setIntradayRSI] = useState(null);
  const [intradayMACD, setIntradayMACD] = useState(null);
  const [searchQuery, setSearchQuery] = useState("");
  const [histData, setHistData] = useState("");

  const [loadingIndicators, setLoadingIndicators] = useState(false);
  const [loading, setLoading] = useState(false);
  const [newsLoading, setNewsLoading] = useState(false);
  const [newsError, setNewsError] = useState();
  const [newsData, setNewsData] = useState();

  const [maData, setMaData] = useState("");
  const [returnData, setReturnData] = useState("");
  const isIndia = market === "india";

  const fetchDailyIndicators = async (symbol) => {
    try {
      const rsi = await axios.get(
        `${BASE_URL}/api/globalRsi?symbol=${symbol}&type=daily`,
      );

      const macd = await axios.get(
        `${BASE_URL}/api/globalMacd?symbol=${symbol}&type=daily`,
      );

      console.log("✅ DAILY RSI RAW:", rsi.data);
      console.log("✅ DAILY MACD RAW:", macd.data);

      setDailyRSI(rsi.data);
      setDailyMACD(macd.data);
    } catch (err) {
      console.error("❌ Daily indicator failed", err);
    }
  };

  const fetchIntradayIndicators = async (symbol) => {
    try {
      const rsi = await axios.get(
        `${BASE_URL}/api/globalRsi?symbol=${symbol}&type=intraday`,
      );

      const macd = await axios.get(
        `${BASE_URL}/api/globalMacd?symbol=${symbol}&type=intraday`,
      );

      console.log("✅ INTRADAY RSI RAW:", rsi.data);
      console.log("✅ INTRADAY MACD RAW:", macd.data);

      setIntradayRSI(rsi.data);
      setIntradayMACD(macd.data);
    } catch (err) {
      console.error("❌ Intraday indicator failed", err);
    }
  };
  const fetchReturnData = async (symbol) => {
    setLoading(true);
    try {
      const response = await axios.get(
        `${BASE_URL}/api/getHistorical/${symbol}`,
      );
      setReturnData(response.data);
      console.log("return data", response.data);
    } catch (err) {
      console.log("Error is ", err.message);
    } finally {
      setLoading(false);
    }
  };
  const fetchMaData = async (symbol) => {
    setLoading(true);
    try {
      const response = await axios.get(`${BASE_URL}/api/globalMa`, {
        params: { symbol: symbol },
      });
      setMaData(response.data);
      console.log("Ma data", response.data);
    } catch (err) {
      console.log("error is:", err.message);
    } finally {
      setLoading(false);
    }
  };
  const fetchAllIndicators = async (symbol) => {
    setLoadingIndicators(true);

    await fetchDailyIndicators(symbol);
    await fetchIntradayIndicators(symbol);

    setLoadingIndicators(false);
  };
  const fetchSearchQuery = async (query) => {
    setLoading(true);
    console.log("Query received is:", query);
    try {
      const response = await axios.get(
        `${BASE_URL}/api/globalSearch?query=${query}`,
      );
      setSearchQuery(response.data);
      console.log("Query response data", response.data);
    } catch (err) {
      console.log("Error is :-", err.message);
    } finally {
      setLoading(false);
    }
  };
  const fetchHistData = async (symbol) => {
    setLoading(true);
    try {
      const response = await axios.get(`${BASE_URL}/api/globalHist`, {
        params: { symbol },
      });
      setHistData(response?.data);
    } catch (err) {
      console.log("Error is:-", err.message);
    } finally {
      setLoading(false);
    }
  };
  //news for all
  const fetchNewsData = async (symbol) => {
    setNewsLoading(true);
    try {
      const response = await axios.get(`${BASE_URL}/api/stocknews`, {
        params: {
          ticker: symbol,
          market: market,
        },
      });
      setNewsData(response.data);
    } catch (err) {
      setNewsError(err.message);
    } finally {
      setNewsLoading(false);
    }
  };

  return (
    <IndicatorContext.Provider
      value={{
        dailyRSI,
        dailyMACD,
        intradayRSI,
        intradayMACD,
        loadingIndicators,
        fetchDailyIndicators,
        fetchIntradayIndicators,
        fetchAllIndicators,
        fetchReturnData,
        returnData,
        fetchMaData,
        maData,
        fetchSearchQuery,
        searchQuery,
        fetchHistData,
        histData,
        fetchNewsData,
        newsError,
        newsLoading,
        newsData,
      }}
    >
      {children}
    </IndicatorContext.Provider>
  );
};

export const useIndicators = () => useContext(IndicatorContext);
